"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4862],{

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 25672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);




const HeroLead = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__lead", className),
        ...props
    });
};
HeroLead.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLead);


/***/ }),

/***/ 72498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);



const HeroVerticalDelimiter = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "span",
        className: "section-hero__vertical_delimiter",
        ...props,
        children: "|"
    });
};
HeroVerticalDelimiter.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroVerticalDelimiter);


/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Line_Line; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/Line.js






const Line = (param)=>{
    let { className ="" , opacity ="" , isGradient =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("line", opacity && "line--opacity-".concat(opacity), isGradient && "line--gradient", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className)
    });
};
Line.propTypes = {
    className: prop_types.string,
    opacity: (0,prop_types.oneOf)([
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ]),
    isGradient: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Line_Line = (Line);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js



/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);




const BackToTopButton = ()=>{
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [prevOffset, setPrevOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const toggleScrollDirection = ()=>{
        const { scrollY  } = window;
        const screenHeight = window.screen.height * 2;
        if (scrollY > prevOffset || scrollY < screenHeight) {
            setShowButton(false);
        } else if (scrollY < prevOffset && scrollY > screenHeight) {
            setShowButton(true);
        }
        setPrevOffset(scrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("scroll", toggleScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "back-to-top-button",
            onClick: scrollToTop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "chevron-up",
                    className: "back-to-top-button--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "back-to-top-button--text",
                    children: "TOP"
                })
            ]
        })
    });
};


/***/ }),

/***/ 94862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Updates; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 11 modules
var i18 = __webpack_require__(8610);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Lead.js
var Lead = __webpack_require__(25672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/VerticalDelimiter.js
var VerticalDelimiter = __webpack_require__(72498);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/UpdatesPageTemplate.js





const UpdatesPageTemplate = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "updates-page-template",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    sm: 12,
                    md: 11,
                    lg: 8,
                    children: children
                })
            })
        })
    });
};
UpdatesPageTemplate.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var UpdatesPageTemplate_UpdatesPageTemplate = (UpdatesPageTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/Title.js




const UpdatesPageTemplateTitle = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        Tag: "h2",
        className: "updates-page-template__title",
        children: children
    });
};
UpdatesPageTemplateTitle.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var UpdatesPageTemplate_Title = (UpdatesPageTemplateTitle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/List.js



const UpdatesPageTemplateList = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list",
        children: children
    });
};
UpdatesPageTemplateList.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var List = (UpdatesPageTemplateList);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/Item.js





const ItemTitle = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item-title",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            className: "updates-page-template__list-item-title-link",
            ...props,
            children: children
        })
    });
};
ItemTitle.propTypes = {
    children: prop_types.node.isRequired
};
const ItemDate = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item-date",
        ...props,
        children: children
    });
};
ItemDate.propTypes = {
    children: prop_types.node.isRequired
};
const ItemImage = (param)=>/*#__PURE__*/ {
    let { src , alt ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item-image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: src,
            alt: alt,
            isBaseUrl: false,
            ...props
        })
    });
};
ItemImage.propTypes = {
    ...ItemImage.propTypes
};
const ItemDescription = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item-description",
        children: children
    });
};
ItemDescription.propTypes = {
    children: prop_types.node.isRequired
};
const ItemAction = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item-action",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            className: "updates-page-template__list-item-action-link",
            ...props,
            children: [
                children,
                " ›"
            ]
        })
    });
};
ItemAction.propTypes = {
    children: prop_types.node.isRequired
};
const UpdatesPageTemplateListItem = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__list-item",
        children: children
    });
};
UpdatesPageTemplateListItem.propTypes = {
    children: prop_types.node.isRequired
};
UpdatesPageTemplateListItem.Title = ItemTitle;
UpdatesPageTemplateListItem.Date = ItemDate;
UpdatesPageTemplateListItem.Image = ItemImage;
UpdatesPageTemplateListItem.Description = ItemDescription;
UpdatesPageTemplateListItem.Action = ItemAction;
/* harmony default export */ var Item = (UpdatesPageTemplateListItem);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UpdatesPageTemplate/Pagination.js



const UpdatesPageTemplatePagination = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "updates-page-template__pagination",
        children: children
    });
};
UpdatesPageTemplatePagination.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Pagination = (UpdatesPageTemplatePagination);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/BackToTopButton/index.js
var BackToTopButton = __webpack_require__(5370);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/HeroBrand.js
var HeroBrand = __webpack_require__(68103);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Pagination/Pagination.js







const Pagination_Item = (param)=>{
    let { icon , active =false , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default.Button */.Z.Button, {
        className: (0,classes/* classes */.S)("pagination__item", active && "pagination__item--active", className),
        disabled: active,
        ...props,
        children: [
            icon === "left" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "long-arrow-left"
                    }),
                    " "
                ]
            }) : null,
            children,
            icon === "right" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "long-arrow-right"
                    })
                ]
            }) : null
        ]
    });
};
Pagination_Item.propTypes = {
    icon: (0,prop_types.oneOf)([
        "left",
        "right"
    ]),
    active: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
const Divider = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "pagination__divider",
        children: "..."
    });
const Pagination_Pagination = (param)=>/*#__PURE__*/ {
    let { align ="center" , className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("pagination", "pagination--".concat(align), className),
        ...props,
        children: children
    });
};
Pagination_Pagination.propTypes = {
    align: sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
Pagination_Pagination.Item = Pagination_Item;
Pagination_Pagination.Divider = Divider;
/* harmony default export */ var atomic_react_Pagination_Pagination = (Pagination_Pagination);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Pagination/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/PagePagination/PagePagination.js





const PagePagination = (param)=>{
    let { total , current  } = param;
    const router = (0,next_router.useRouter)();
    const max = 3;
    const config = (0,react.useMemo)(()=>{
        let maxLinks = max + 1;
        let h = 1;
        if (current > maxLinks) {
            h = h + current - maxLinks;
        }
        if (current >= 1) {
            maxLinks = maxLinks + current - 1;
        }
        if (maxLinks > total) {
            maxLinks = total + 1;
        }
        return {
            start: h,
            end: maxLinks
        };
    }, [
        max,
        current,
        total
    ]);
    const changePage = (0,react.useCallback)((page)=>{
        const { page: currentPage , ...query } = router.query || {};
        if (page === 1) {
            router.push({
                pathname: router.pathname,
                query
            });
        } else {
            router.push({
                pathname: router.pathname,
                query: {
                    ...query,
                    page
                }
            });
        }
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (+((ref = router.query) === null || ref === void 0 ? void 0 : ref.page) === 1) {
            const { page , ...query } = router.query;
            router.push({
                pathname: router.pathname,
                query
            });
        }
    }, [
        router
    ]);
    return total > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Pagination_Pagination, {
        children: [
            current > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Pagination_Pagination.Item, {
                icon: "left",
                onClick: ()=>changePage(current - 1),
                children: "Previous"
            }) : null,
            new Array(config.end - config.start).fill().map((_, index)=>{
                const page = config.start + index;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Pagination_Pagination.Item, {
                    active: page === current,
                    onClick: ()=>changePage(page),
                    children: page
                }, "pagination_page_".concat(page));
            }),
            current < total ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Pagination_Pagination.Item, {
                icon: "right",
                onClick: ()=>changePage(current + 1),
                children: "Next"
            }) : null
        ]
    }) : null;
};
PagePagination.propTypes = {
    total: prop_types.number.isRequired,
    current: prop_types.number.isRequired
};
/* harmony default export */ var PagePagination_PagePagination = (PagePagination);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/PagePagination/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js + 5 modules
var richTextTypes_default = __webpack_require__(34124);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Updates/components/SectionHero/heroConfig.js
const heroConfig = {
    color: {
        sg: "1",
        gn: "1",
        gp: "1"
    }
};
/* harmony default export */ var SectionHero_heroConfig = (heroConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Updates/Page.js


























const UpdatesPage = (param)=>{
    let { page , pageProps  } = param;
    const [t] = (0,i18/* useLocale */.bU)("updates");
    const { siteDomain , brandCode  } = pageProps;
    const { latestVersion ={}  } = page;
    const { pagination =null  } = page;
    const { releaseNotes =[]  } = page;
    const hoverColor = brandCode === constants/* BRAND_CODE_SG */.ec ? "3" : "white";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        url: "".concat(siteDomain, "/updates")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "".concat(siteDomain, "/updates")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBrand/* default */.Z, {
                brandCode: brandCode,
                config: SectionHero_heroConfig,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    children: t("HERO.PRISM_UPDATES")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Lead/* default */.Z, {
                                    sx: {
                                        fontSize: "xl"
                                    },
                                    children: [
                                        t("HERO.THE_LATEST_PRISM_VERSION_IS"),
                                        " ",
                                        latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.version,
                                        brandCode === constants/* BRAND_CODE_GP */.yB ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                " (Windows ",
                                                t("HERO.AND"),
                                                " Mac)"
                                            ]
                                        }) : null,
                                        "."
                                    ]
                                })
                            ]
                        })
                    }),
                    brandCode === constants/* BRAND_CODE_GP */.yB || brandCode === constants/* BRAND_CODE_SG */.ec ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
                                    sm: 12,
                                    md: 8,
                                    sx: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                            opacity: 20,
                                            spacing: {
                                                mt: 6,
                                                mb: 8
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white"
                                            },
                                            children: [
                                                t("HERO.HOW_TO_UPDATE_TO_PRISM"),
                                                " ",
                                                latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.majorVersion
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontWeight: "medium"
                                            },
                                            children: t("HERO.SUBSCRIBERS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white--80"
                                            },
                                            children: [
                                                t("HERO.UPDATE_FOR_FREE"),
                                                " (",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    color: "4",
                                                    hoverColor: hoverColor,
                                                    href: t("HERO.INSTRUCTION_LINK"),
                                                    children: t("HERO.INSTRUCTION_TITLE")
                                                }),
                                                "):"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                textAlign: "center"
                                            },
                                            spacing: {
                                                my: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    color: "4",
                                                    hoverColor: hoverColor,
                                                    href: latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.windowsInstallerUrl,
                                                    children: "Windows"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDelimiter/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    color: "4",
                                                    hoverColor: hoverColor,
                                                    href: latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.macInstallerUrl,
                                                    children: "Mac"
                                                }),
                                                brandCode === constants/* BRAND_CODE_SG */.ec && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDelimiter/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            color: "4",
                                                            hoverColor: hoverColor,
                                                            href: latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.redHatInstallerUrl,
                                                            children: "RedHat"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDelimiter/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            color: "4",
                                                            hoverColor: hoverColor,
                                                            href: latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.ubuntuInstallerUrl,
                                                            children: "Ubuntu"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
                                    sm: 12,
                                    md: 8,
                                    sx: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontWeight: "medium"
                                            },
                                            children: t("HERO.LICENSE_CUSTOMERS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white--80"
                                            },
                                            children: [
                                                t("HERO.CONTACT_US_AT"),
                                                " \xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    color: "4",
                                                    hoverColor: hoverColor,
                                                    href: t("HERO.CONTACT_LINK_HREF"),
                                                    children: t("HERO.CONTACT_LINK_TITLE")
                                                }),
                                                "\xa0 ",
                                                t("HERO.TO_LEARN_ABOUT_UPGRADE_OPTIONS"),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UpdatesPageTemplate_UpdatesPageTemplate, {
                children: [
                    brandCode !== constants/* BRAND_CODE_OM */.h7 && /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatesPageTemplate_Title, {
                        children: t("UPDATES.LATEST_RELEASES")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        children: releaseNotes.map((item)=>{
                            var ref;
                            const releaseDate = new Date(item.fields.releaseDate);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                                        Component: Item.Title,
                                        href: "/updates/".concat(item.fields.slug),
                                        children: [
                                            t("PRODUCT_NAME"),
                                            " ",
                                            ((ref = item.fields) === null || ref === void 0 ? void 0 : ref.appVersionNumber) || ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item.Date, {
                                        suppressHydrationWarning: true,
                                        children: t("{{releaseDate, LONGDATE}}", {
                                            releaseDate
                                        })
                                    }),
                                    item.fields.teaser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Item.Description, {
                                        children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(item.fields.teaser, richTextTypes_default/* default */.Z)
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Item.Action,
                                        href: "/updates/".concat(item.fields.slug),
                                        children: t("UPDATES.DETAILS")
                                    })
                                ]
                            }, item.fields.title);
                        })
                    }),
                    pagination ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PagePagination_PagePagination, {
                            ...pagination
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTopButton/* BackToTopButton */.z, {})
        ]
    });
};
UpdatesPage.propTypes = {
    page: (0,prop_types.shape)({
        latestVersion: (0,prop_types.shape)({
            version: prop_types.string,
            majorVersion: prop_types.string,
            macInstallerUrl: prop_types.string,
            windowsInstallerUrl: prop_types.string
        }),
        releaseNotes: (0,prop_types.arrayOf)((0,prop_types.shape)({
            appReleaseNotes: prop_types.object,
            appVersionNumber: prop_types.string,
            body: prop_types.object,
            macInstallerUrl: prop_types.string,
            publishStatus: (0,prop_types.oneOf)([
                "Hidden",
                constants/* PUBLISHED */.lc
            ]),
            releaseDate: prop_types.string,
            slug: prop_types.string,
            teaser: prop_types.object,
            title: prop_types.string,
            windowsInstallerUrl: prop_types.string
        }))
    }),
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string.isRequired
    })
};
/* harmony default export */ var Page = (UpdatesPage);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/utils/pagination/index.js
const getQueryPage = (query)=>+query.page || 1;
const paginationInit = (perPage, currentPage)=>{
    return {
        limit: +perPage,
        skip: +perPage * (+currentPage - 1)
    };
};
const paginationConfig = (items, perPage, currentPage)=>{
    const divider = +items % +perPage;
    return {
        pagination: {
            total: divider === 0 ? +items / +perPage : (+items - divider) / +perPage + 1,
            current: +currentPage
        }
    };
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/contentfulSanitizer.js
var contentfulSanitizer = __webpack_require__(50420);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Updates/index.js













const ContentfulUpdatesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulUpdatesPage = (param)=>{
        let { page  } = param;
        const { brandCode , resources =null  } = pageProps;
        const PageComponent = pageProps.PageComponent || Page;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageComponent, {
                    page: page,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulUpdatesPage.getInitialProps = async (param)=>{
        let { query  } = param;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        const page = getQueryPage(query);
        const client = (0,createClient/* default */.Z)(contentfulProps);
        const latestVersionData = await client.getEntries({
            content_type: "pageReleaseNotes",
            order: "-fields.releaseDate",
            "fields.publishStatus": constants/* PUBLISHED */.lc,
            skip: 0,
            limit: 1
        });
        const latestVersion = ((ref = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref === void 0 ? void 0 : ref.fields) ? {
            version: ((ref1 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.appVersionNumber) || "",
            majorVersion: ((ref3 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.appVersionNumber.split(".")[0]) || "",
            windowsInstallerUrl: ((ref5 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.windowsInstallerUrl) || "",
            macInstallerUrl: ((ref7 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.macInstallerUrl) || "",
            redHatInstallerUrl: ((ref9 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.redHatInstallerUrl) || "",
            ubuntuInstallerUrl: ((ref11 = latestVersionData === null || latestVersionData === void 0 ? void 0 : latestVersionData.items[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : ref12.ubuntuInstallerUrl) || ""
        } : {};
        const contentfulResponse = await client.getEntries({
            content_type: "pageReleaseNotes",
            order: "-fields.releaseDate",
            "fields.publishStatus": constants/* PUBLISHED */.lc,
            ...paginationInit(constants/* RELEASE_NOTES_PER_PAGE */.Ub, page)
        });
        if (contentfulResponse.total === 0) {
            return {
                page: null
            };
        }
        return {
            page: {
                latestVersion,
                releaseNotes: (0,contentfulSanitizer/* sanitize */.N)(contentfulResponse.items),
                ...paginationConfig(contentfulResponse.total, constants/* RELEASE_NOTES_PER_PAGE */.Ub, page)
            }
        };
    };
    ContentfulUpdatesPage.propTypes = {
        ...Page.propTypes
    };
    ContentfulUpdatesPage.postConditions = [
        [
            (param)=>{
                let { page  } = param;
                return page;
            },
            (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
        ]
    ];
    return (0,pipe/* default */.Z)(ContentfulUpdatesPage, WithConditions/* default */.ZP);
};
/* harmony default export */ var Updates = (ContentfulUpdatesFactory);


/***/ }),

/***/ 34491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ RELEASE_NOTES_PER_PAGE; },
/* harmony export */   "_E": function() { return /* binding */ GUIDE_TYPES; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "ec": function() { return /* binding */ BRAND_CODE_SG; },
/* harmony export */   "gf": function() { return /* binding */ BRAND_CODE_LA; },
/* harmony export */   "h7": function() { return /* binding */ BRAND_CODE_OM; },
/* harmony export */   "lc": function() { return /* binding */ PUBLISHED; },
/* harmony export */   "yB": function() { return /* binding */ BRAND_CODE_GP; }
/* harmony export */ });
/* unused harmony exports BLOGS_PER_PAGE, BRAND_CODE_GN */
const RELEASE_NOTES_PER_PAGE = 20;
const BLOGS_PER_PAGE = 12;
const BRAND_CODE_GP = "gp";
const BRAND_CODE_SG = "sg";
const BRAND_CODE_GN = "gn";
const BRAND_CODE_OM = "om";
const BRAND_CODE_LA = "la";
const PUBLISHED = "Live";
const GUIDE_TYPES = {
    Guide: "guide",
    Tutorial: "tutorial"
};
const BRAND_NAMES = {
    om: "OMIQ",
    sg: "Snapgene",
    gp: "Graphpad",
    gn: "Geneious",
    la: "LabArchives"
};


/***/ }),

/***/ 68103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69591);




const HeroBrand = (param)=>{
    let { brandCode ="sg" , config , children , ...props } = param;
    const { color  } = config;
    const brandColor = (brand)=>color[brand];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: brandColor(brandCode),
        ...props,
        children: children
    });
};
HeroBrand.propTypes = {
    brandCode: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "sg",
        "gp",
        "gn",
        "om",
        "la"
    ]),
    config: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
        color: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
            gn: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            sg: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            gp: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            om: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            la: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
        })
    }),
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroBrand);


/***/ })

}]);